var _circle, _ellipse, _ellipse2, _path, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmileyDoNotKnow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    enableBackground: "new 0 0 1024 1024",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_543S5DRG4S3DRGSDG3_",
    cx: 512,
    cy: 512,
    r: 452.6073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AC1268"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    style: {
      stopColor: "#AA1367"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7501,
    style: {
      stopColor: "#A31466"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8912,
    style: {
      stopColor: "#981765"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9985,
    style: {
      stopColor: "#881A62"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_543S5DRG4S3DRGSDG3_)",
    cx: 512,
    cy: 512,
    r: 452.6
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3158 -0.9488 0.9488 0.3158 -33.5462 532.8658)",
    cx: 352.7,
    cy: 289.7,
    rx: 90.1,
    ry: 58.8
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9974 -7.137749e-02 7.137749e-02 0.9974 -22.0393 51.1918)",
    cx: 705.3,
    cy: 334,
    rx: 58.8,
    ry: 90.1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 28.2902,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: "M706.2,595C564,514.2,356.9,555.5,275.9,700"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000047759756110204464740000002351896377566277279_",
    cx: 512,
    cy: 512,
    r: 505.8947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AC1268"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5515,
    style: {
      stopColor: "#AA1367"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7501,
    style: {
      stopColor: "#A31466"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8912,
    style: {
      stopColor: "#981765"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9985,
    style: {
      stopColor: "#881A62"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "url(#SVGID_00000047759756110204464740000002351896377566277279_)",
    strokeWidth: 12.3137,
    strokeMiterlimit: 10,
    cx: 512,
    cy: 512,
    r: 499.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileyDoNotKnow);
export default __webpack_public_path__ + "static/media/smiley-do-not-know.1a8ea456896840b18b42095a677c714d.svg";
export { ForwardRef as ReactComponent };